const { Keywords } = require('../core/keywords');

/**
 * Supported Escape Characters:
 * \n - Newline
 * \t - Tab
 * \r - Carriage Return
 * \" - Double Quote
 * \' - Single Quote
 * \\ - Backslash
 */

module.exports = {
    [Keywords.PROGRAM_START]: 'नमस्कार {{name}}',
    [Keywords.PROGRAM_END]: 'येतो {{name}}',
    [Keywords.PRINT]: 'बोल {{name}}',
    [Keywords.VARIABLE]: '{{name}} हे आहे',
    [Keywords.UNTIL]: 'जो पर्यन्त {{name}}',
    [Keywords.IF]: 'जर {{name}}',
    [Keywords.ELSE]: 'तर {{name}}',
    [Keywords.FOR]: 'आवर्तन {{name}}',
    [Keywords.BREAK]: 'थांब {{name}}',
    [Keywords.CONTINUE]: 'चालत रहा {{name}}',
    [Keywords.TRUE]: 'नीट',
    [Keywords.FALSE]: 'चूक',
    [Keywords.AND]: 'आणी',
    [Keywords.OR]: 'नहीं तर',
    [Keywords.LENGTH]: 'लांबी',
    [Keywords.INPUT]: 'विचार {{name}}'
};
